var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TagContainer, TagFont } from './styles';
export var tagDefine = function (value, type) {
    return (_jsx(TagContainer, __assign({ type: type }, { children: _jsx(TagFont, __assign({ type: type }, { children: value })) })));
};
